import { useRef, useEffect } from 'react';

const useFirstMount = () => {
  const firstRender = useRef(true);

  useEffect(() => {
    firstRender.current = false;
  }, []);

  return firstRender.current;
};
export default useFirstMount;
